module.exports = __webpack_public_path__ + "static/security-2ee47a2340c4024f01e7d0b4e320f66f.jpg";